import { getApi } from "../helpers/api";

async function update(endpoint: string, id: number, data: any) {
  return getApi().put(`/${endpoint}/${id}`, data);
}

export default update;
